import React from 'react'
import { Chart } from "react-google-charts";
import { applyCustomTableStyling, hideRepeatedTableColumnValues } from '../insights_functions';

const InsightCrossTabView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        // console.log("layout response view", viewData.ViewData[currentOption].ChartData);
        const chartData = viewData.ViewData[currentOption].ChartData;
        const rawChartOptions = viewData.ChartConfig?.options || {
                    title: "",
                    allowHtml: true,
                    showRowNumber: true,
                    legend: { position: "bottom" },
                    pageSize: 15,
                };
        const { hideRepeatedColumns, ...chartOptions } = rawChartOptions;
        const chartFormatters = viewData.ChartConfig?.formatters || [];
        const customFormatters = viewData.ChartConfig?.customFormatters || [];
        const displayChartData = applyCustomTableStyling(
            hideRepeatedTableColumnValues(chartData, hideRepeatedColumns),
            customFormatters
        );

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <div className="uiInsightTableView">
            <Chart
                chartType="Table"
                data={displayChartData}
                options={chartOptions}
                formatters={chartFormatters}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
            </div>
        )
    }

    return null;
}

export default InsightCrossTabView
